module.exports = __webpack_public_path__ + "static/media/default-banner.72869a0f.jpg";